// 
import { axiosApi } from "./api"
import store from "../store/index"

//
export const play = {
    currentProjectInfo() {
        return axiosApi("get", "/project/info")({ projectId: store.getters.projectId })
    }
    ,
    freshToken: () => {
        return axiosApi("get", "/token/fresh")()
    },
    firmInfo: () => {
        return axiosApi("get", "/firm/currentUser")()
    },
    //登录接口
    login: (data) => {
        //使用留创园凯俊昌华等账号登录
        // return axiosApi("post", "/user/firm/login")({
        //新增山东鲁泰后台管理信息需要登录接口//田洒注册
        return axiosApi("post", "/user/tel/login")(data)
    },
    //管理员登陆
    Homelogin:(tel, psw) => {
        //同上
        //新增山东鲁泰后台管理信息需要登录接口//田洒注册
        return axiosApi("post", "/user/firm/login")({
            tel, psw
        })
    },
    sendEmail: email => {
        return axiosApi("post", "/email/code")({
            email
        })
    },
    changePassword: (code, email, psw) => {
        return axiosApi("post", '/user/rePsw/email')({
            code, email, psw
        })
    },
    // firmId,
    //登陆后修改密码
    loginpass: ( newPsw, oldPsw) => {
        return axiosApi("put", '/user/updatedepsw')({
            newPsw, oldPsw
        })
    },
    userUpdate: (data) => {
        return axiosApi("put", '/user/v3/update',true)(data)
    },
    // 给手机发送验证码
    getVerificationCode:(data) => {
        return axiosApi("post", '/code/login/code')(data)
    },
    // 获取验证码登录随机key
    getKeyVerification: (data) => {
        return axiosApi("post", '/code/login/code')(data)
    },
    // 用户验证码登录
    verificationLogin: (data) =>{
        return axiosApi('post', '/user/tel/code/login')(data)
    }
}
